<template>
  <div class="p-formgrid p-grid ">
    <!-- Province -->
    <div class="card p-fluid p-col-12 p-lg-4">
      <DataTable
        :value="province_table"
        :paginator="true"
        :rows="10"
        :selection.sync="selectedProvince"
        selectionMode="single"
        @row-select="onRowSelectProvince"
        dataKey="province_id"
        :filters="filters"
        sortField="province_name"
        :sortOrder="1"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
      >
        <template #header>
          <div class="p-formgrid p-grid">
            <div class="table-header p-col-12 p-lg-3 p-mt-2">
              <Button 
                @click="provinceModal = true
                province_load()"
                :label="$t('addBtn')"
                class="p-button-success"
                v-if="checkAdd_data != 'false'"
              />
            </div>
            <div class="table-header p-col-12 p-lg-4 p-mt-2" style="margin-left: auto">
              <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['province_name']"
                  :placeholder="$t('searchHeader')"
                />
              </span>
            </div>
          </div>
        </template>
        <template #empty>{{ $t("TableEmpty") }}</template>
        <Column
          field="province_name"
          :header="$t('country_province_name')"
          :sortable="true"
        >
          <template #body="dataTable">
            <div hidden>{{ dataTable.data.province_id }}</div>
            {{ dataTable.data.province_name }}
          </template>
        </Column>
        <Column :header="$t('controlTable')" v-if="checkEdit_data != 'false' || checkDelete_data != 'false' " :headerStyle="{textAlign:'center'}">
          <template #body="dataTable">
            <div class="p-formgrid p-grid">
              <div class="p-field p-col" v-if="checkEdit_data != 'false'">
                <Button
                  @click="
                    provinceModal = true;
                    editProvince(dataTable.data.province_id);
                    temp = dataTable.data.province_id;
                  "
                  icon="pi pi-pencil"
                  :label="$t('editBtn')"
                  class="p-button-rounded p-button-warning"
                />
              </div>
              <div class="p-field p-col" v-if="checkDelete_data != 'false'">
                <Button
                  @click="
                    // displayConfirmation = true;
                    temp = dataTable.data.province_id;
                    alertDisplay(temp);
                    deleteAt = 'province';
                  "
                  icon="pi pi-trash"
                  :label="$t('deleteBtn')"
                  class="p-button-rounded p-button-danger"
                />
              </div>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>

    <!-- Amphur -->
    <div class="card p-fluid p-col-12 p-lg-4">
      <DataTable
        :value="amphur_table"
        :paginator="true"
        :rows="10"
        :selection.sync="selectedAmphur"
        selectionMode="single"
        @row-select="onRowSelectAmphur"
        dataKey="amphur_id"
        :rowHover="true"
        :filters="filters"
        sortField="amphur_name"
        :sortOrder="1"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
      >
        <template #header>
          <div class="p-formgrid p-grid">
            <div class="table-header p-col-12 p-lg-3 p-mt-2">
              <Button
                @click="amphurModal = true
                amphur_load()"
                :label="$t('addBtn')"
                class="p-button-success"
                :disabled="isDisabledAddAmphur == 1"
                v-if="checkAdd_data != 'false'"
              />
            </div>
            <div class="table-header p-col-12 p-lg-4 p-mt-2" style="margin-left: auto">
              <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['amphur_name']"
                  :placeholder="$t('searchHeader')"
                />
              </span>
            </div>
          </div>
        </template>
        <template #empty>{{ $t("TableEmpty") }}</template>
        <Column
          field="amphur_name"
          :header="$t('country_amphur_name')"
          :sortable="true"
        >
          <template #body="dataTable">
            <div hidden>{{ dataTable.data.amphur_id }}</div>
            {{ dataTable.data.amphur_name }}
          </template>
        </Column>
        <Column :header="$t('controlTable')" v-if="checkEdit_data != 'false' || checkDelete_data != 'false' " :headerStyle="{textAlign:'center'}">
          <template #body="dataTable">
            <div class="p-formgrid p-grid">
              <div class="p-field p-col" v-if="checkEdit_data != 'false'">
                <Button
                  @click="
                    amphurModal = true;
                    editAmphur(dataTable.data.amphur_id);
                    temp = dataTable.data.amphur_id;
                  "
                  icon="pi pi-pencil"
                  :label="$t('editBtn')"
                  class="p-button-rounded p-button-warning"
                />
              </div>
              <div class="p-field p-col" v-if="checkDelete_data != 'false'"
>
                <Button
                  @click="
                    // displayConfirmation = true;
                    temp = dataTable.data.amphur_id;
                    alertDisplay(temp);
                    deleteAt = 'amphur';
                  "
                  icon="pi pi-trash"
                  :label="$t('deleteBtn')"
                  class="p-button-rounded p-button-danger"
                />
              </div>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>

    <!-- Tambon -->
    <div class="card p-fluid p-col-12 p-lg-4">
      <DataTable
        :value="tambon_table"
        :paginator="true"
        :rows="10"
        dataKey="id"
        :rowHover="true"
        :filters="filters"
        sortField="tambon_name"
        :sortOrder="1"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
      >
        <template #header>
          <div class="p-formgrid p-grid">
            <div class="table-header p-col-12 p-lg-3 p-mt-2">
              <Button
                @click="tambonModal = true
                tambon_load()"
                :label="$t('addBtn')"
                class="p-button-success"
                :disabled="isDisabledAddTambon == 1"
                v-if="checkAdd_data != 'false'"

              />
            </div>
            <div class="table-header p-col-12 p-lg-4 p-mt-2" style="margin-left: auto">
              <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['tambon_name']"
                  :placeholder="$t('searchHeader')"
                />
              </span>
            </div>
          </div>
        </template>
        <template #empty>{{ $t("TableEmpty") }}</template>
        <Column
          field="tambon_name"
          :header="$t('country_tambon_name')"
          :sortable="true"
        >
          <template #body="dataTable">
            <div hidden>{{ dataTable.data.tambon_id }}</div>
            {{ dataTable.data.tambon_name }}
          </template>
        </Column>
        <Column :header="$t('controlTable')" v-if="checkEdit_data != 'false' || checkDelete_data != 'false' " :headerStyle="{textAlign:'center'}">
          <template #body="dataTable" >
            <div class="p-formgrid p-grid">
              <div class="p-field p-col" v-if="checkEdit_data != 'false'">
                <Button
                  @click="
                    tambonModal = true;
                    editTambon(dataTable.data.tambon_id);
                    temp = dataTable.data.tambon_id;
                  "
                  icon="pi pi-pencil"
                  :label="$t('editBtn')"
                  class="p-button-rounded p-button-warning"
                />
              </div>
              <div class="p-field p-col" v-if="checkDelete_data != 'false'">
                <Button
                  @click="
                    // displayConfirmation = true;
                    temp = dataTable.data.tambon_id;
                    alertDisplay(temp);
                    deleteAt = 'tambon';
                  "
                  icon="pi pi-trash"
                  :label="$t('deleteBtn')"
                  class="p-button-rounded p-button-danger"
                />
              </div>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>

    <!-- Manage province -->
    <Dialog
      :modal="true"
      :visible.sync="provinceModal"
      :style="{ width: '500px' }"
      :header="header_province"
    >
      <div class="confirmation-content">
        <label>{{ $t("country_province_modal_subtitle") }}</label>
        <div class="p-fluid p-mt-3">
          
            <div v-if="header_province == this.$i18n.t('country_province_modal_title_edit')"
            style="display: flex;">
                <!-- <div class="p-formgrid p-grid">
                  <div class="p-field p-col-4">
                    <label for="country_province_code"
                      >{{ $t("country_province_code") }}
                      <span class="required-input">*</span></label
                    >
                    <InputNumber
                      id="country_province_code"
                      v-model="country_province_code"
                      :useGrouping="false"
                      required="true"
                      autofocus
                      :class="{
                        'p-invalid':
                          error_country_province_code && !country_province_code,
                      }"
                    />
                    <small
                      class="p-invalid"
                      v-if="error_country_province_code && !country_province_code"
                      >{{ $t("country_province_code_validate") }}</small
                    >
                  </div>
                  <div class="p-field p-col-12 p-mt-2">
                    <label for="country_province_name"
                      >{{ $t("country_province_name") }}
                      <span class="required-input">*</span></label
                    >
                    <InputText
                      id="country_province_name"
                      type="text"
                      v-model="country_province_name"
                      required="true"
                      autofocus
                      :class="{
                        'p-invalid':
                          error_country_province_name && !country_province_name,
                      }"
                    />
                    <small
                      class="p-invalid"
                      v-if="error_country_province_name && !country_province_name"
                      >{{ $t("country_province_name_validate") }}</small
                    >
                  </div>
                </div> -->
                <div class="p-field p-col-12 p-mt-2">
                    <label for="country_province_name"
                      >{{ $t("country_province_name") }}
                      <span class="required-input">*</span></label
                    >
                    <InputText
                      id="country_province_name"
                      type="text"
                      v-model="country_province_name"
                      required="true"
                      autofocus
                      :class="{
                        'p-invalid':
                          error_country_province_name && !country_province_name,
                      }"
                    />
                    <small
                      class="p-invalid"
                      v-if="error_country_province_name && !country_province_name"
                      >{{ $t("country_province_name_validate") }}</small
                    >
                  </div>
            </div>
            <div v-else>
              <!-- เพิ่ม -->
                <div class="p-field p-col-12">
                  <label for="provinceOptions"
                    >{{ $t("province") }}
                    <span class="required-input">*</span></label
                  >
                  <Dropdown
                    v-model="province_table_Select"
                    :options="province_table_Options"
                    optionLabel="province_name"
                    :filter="true"
                    
                    :class="{
                      'p-invalid': error_select_province && !province_table_Select,
                    }"
                    :placeholder="$t('placeholderSelectBox')"
                    :showClear="true"
                    :clearFilterDropdown="dropdownClearFilerValue"
                  >
                    <template #value="provinceOptions">
                      <div v-if="provinceOptions.value">
                        <div>{{ provinceOptions.value.province_name }}</div>
                      </div>
                      <span v-else>
                        {{ provinceOptions.placeholder }}
                      </span>
                    </template>
                    <template #option="provinceOptions">
                      <div>{{ provinceOptions.option.province_name }}</div>
                    </template>
                  </Dropdown>
                  <small
                    class="p-invalid"
                    v-if="(error_select_province && !province_table_Select)"
                    >{{ $t("country_select_province_validate") }}</small
                  >
                </div>
             
            </div>
          
        </div>
      </div>
      <template #footer>
        <Button
          v-if="selectedDataProvince != ''"
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearData()"
        />
        <Button
          v-else
          :label="$t('clearBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearData()"
        />
        <Button
          v-if="selectedDataProvince != ''"
          :label="$t('saveBtn')"
          icon="pi pi-check"
          class="p-button-text"
          @click="saveProvince()"
        />
        <!-- เพิ่ม -->
        <Button
          v-else
          :label="$t('saveBtn')"
          icon="pi pi-check"
          class="p-button-text"
          @click="saveProvince2()"
        />
      </template>
    </Dialog>

    <!-- Manage amphur -->
    <Dialog
      :modal="true"
      :visible.sync="amphurModal"
      :style="{ width: '500px' }"
      :header="header_amphur"
    >
      <div class="confirmation-content">
        <label>{{ $t("country_amphur_modal_subtitle") }}</label>
      <div class="p-fluid p-mt-3">

          <div v-if="header_amphur == this.$i18n.t('country_amphur_modal_title_edit')">
              <div class="p-formgrid p-grid">
                <div class="p-field p-col-12">
                  <label for="provinceOptions"
                    >{{ $t("province") }}
                    <!-- <span class="required-input">*</span> -->
                    </label
                  >
                  <Dropdown
                    :disabled="true"
                    v-model="provinceSelect"
                    :options="provinceOptions"
                    optionLabel="province_name"
                    :filter="true"
                    :class="{
                      'p-invalid': error_select_province && !provinceSelect,
                    }"
                    :placeholder="$t('placeholderSelectBox')"
                    :showClear="true"
                    :clearFilterDropdown="dropdownClearFilerValue"
                  >
                    <template #value="provinceOptions">
                      <div v-if="provinceOptions.value">
                        <div>{{ provinceOptions.value.province_name }}</div>
                      </div>
                      <span v-else>
                        {{ provinceOptions.placeholder }}
                      </span>
                    </template>
                    <template #option="provinceOptions">
                      <div>{{ provinceOptions.option.province_name }}</div>
                    </template>
                  </Dropdown>
                  <small
                    class="p-invalid"
                    v-if="error_select_province && !provinceSelect"
                    >{{ $t("country_select_province_validate") }}</small
                  >
                </div>
              </div>
          
              <div class="p-formgrid p-grid p-mt-3">
                <!-- <div class="p-field p-col-4">
                  <label for="country_amphur_code"
                    >{{ $t("country_amphur_code") }}
                    <span class="required-input">*</span></label
                  >
                  <InputNumber
                    id="country_amphur_code"
                    v-model="country_amphur_code"
                    required="true"
                    :useGrouping="false"
                    autofocus
                    :class="{
                      'p-invalid':
                        error_country_amphur_code && !country_amphur_code,
                    }"
                  />
                  <small
                    class="p-invalid"
                    v-if="error_country_amphur_code && !country_amphur_code"
                    >{{ $t("country_amphur_code_validate") }}</small
                  >
                </div> -->
                <div class="p-field p-col-12 p-mt-2">
                  <label for="country_amphur_name"
                    >{{ $t("country_amphur_name") }}
                    <span class="required-input">*</span></label
                  >
                  <InputText
                    id="country_amphur_name"
                    type="text"
                    v-model="country_amphur_name"
                    required="true"
                    autofocus
                    :class="{
                      'p-invalid':
                        error_country_amphur_name && !country_amphur_name,
                    }"
                  />
                  <small
                    class="p-invalid"
                    v-if="error_country_amphur_name && !country_amphur_name"
                    >{{ $t("country_amphur_name_validate") }}</small
                  >
                </div>
              </div>
          </div>
          <!-- เพิ่ม -->
          <div v-else>
              <div class="p-formgrid p-grid">
                <div class="p-field p-col-12">
                  <label for="provinceOptions"
                    >{{ $t("province") }}
                    <!-- <span class="required-input">*</span> -->
                    </label
                  >
                  <Dropdown
                    v-model="provinceSelect"
                    :disabled="true"
                    :options="provinceOptions"
                    optionLabel="province_name"
                    :filter="true"
                    :class="{
                      'p-invalid': error_select_province && !provinceSelect,
                    }"
                    :placeholder="$t('placeholderSelectBox')"
                    :showClear="true"
                    :clearFilterDropdown="dropdownClearFilerValue"
                  >
                    <template #value="provinceOptions">
                      <div v-if="provinceOptions.value">
                        <div>{{ provinceOptions.value.province_name }}</div>
                      </div>
                      <span v-else>
                        {{ provinceOptions.placeholder }}
                      </span>
                    </template>
                    <template #option="provinceOptions">
                      <div>{{ provinceOptions.option.province_name }}</div>
                    </template>
                  </Dropdown>
                  <small
                    class="p-invalid"
                    v-if="error_select_province && !provinceSelect"
                    >{{ $t("country_select_province_validate") }}</small
                  >
                </div>
              </div>
          
              <div class="p-formgrid p-grid p-mt-3">
                <div class="p-field p-col-12 p-mt-2">
                  <label for="country_amphur_name"
                    >{{ $t("country_amphur_name") }}
                    <span class="required-input">*</span></label
                  >
                  
                  <Dropdown
                    v-model="amphur_table_Select"
                    :options="amphur_table_Options"
                    optionLabel="amphur_name"
                    required="true"
                    :filter="true"
                    :class="{
                      'p-invalid':
                        error_country_amphur_name && !amphur_table_Select,
                    }"
                    :placeholder="$t('placeholderSelectBox')"
                    :showClear="true"
                    :clearFilterDropdown="dropdownClearFilerValue"
                  >
                    <template #value="amphurOptions">
                      <div v-if="amphurOptions.value">
                        <div>{{ amphurOptions.value.amphur_name }}</div>
                      </div>
                      <span v-else>
                        {{ amphurOptions.placeholder }}
                      </span>
                    </template>
                    <template #option="amphurOptions">
                      <div>{{ amphurOptions.option.amphur_name }}</div>
                    </template>
                  </Dropdown>
                  <small
                    class="p-invalid"
                    v-if="(error_country_amphur_name && !amphur_table_Select)"
                    >{{ $t("country_amphur_name_validate") }}</small
                  >
                </div>
              </div>
          </div>

        </div>
      </div>
      <template #footer>
        <Button
          v-if="selectedDataAmphur != ''"
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearData()"
        />
        <Button
          v-else
          :label="$t('clearBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearData()"
        />
        <Button
          v-if="selectedDataAmphur != ''"
          :label="$t('saveBtn')"
          icon="pi pi-check"
          class="p-button-text"
          @click="saveAmphur()"
        />
        <Button
          v-else
          :label="$t('saveBtn')"
          icon="pi pi-check"
          class="p-button-text"
          @click="saveAmphur2()"
        />
      </template>
    </Dialog>

    <!-- Manage tambon -->
    <Dialog
      :modal="true"
      :visible.sync="tambonModal"
      :style="{ width: '500px' }"
      :header="header_tambon"
    >
      <div class="confirmation-content">
        <label>{{ $t("country_tambon_modal_subtitle") }}</label>
        <div class="p-fluid p-mt-3">
          <div v-if="header_tambon == this.$i18n.t('country_tambon_modal_title_edit')">
              <div class="p-formgrid p-grid">
                <div class="p-field p-col-6">
                  <label for="provinceOptions"
                    >{{ $t("province") }}
                    <!-- <span class="required-input">*</span> -->
                    </label
                  >
                  <Dropdown
                    v-model="provinceSelect"
                    @change="someHandler"
                    :disabled="true"
                    :options="provinceOptions"
                    optionLabel="province_name"
                    :filter="true"
                    :class="{
                      'p-invalid': error_select_province && !provinceSelect,
                    }"
                    :placeholder="$t('placeholderSelectBox')"
                    :showClear="true"
                    :clearFilterDropdown="dropdownClearFilerValue"
                  >
                    <template #value="provinceOptions">
                      <div v-if="provinceOptions.value">
                        <div>{{ provinceOptions.value.province_name }}</div>
                      </div>
                      <span v-else>
                        {{ provinceOptions.placeholder }}
                      </span>
                    </template>
                    <template #option="provinceOptions">
                      <div>{{ provinceOptions.option.province_name }}</div>
                    </template>
                  </Dropdown>
                  <small
                    class="p-invalid"
                    v-if="error_select_province && !provinceSelect"
                    >{{ $t("country_select_province_validate") }}</small
                  >
                </div>
                <div class="p-field p-col-6">
                  <label for="amphurOptions"
                    >{{ $t("amphur") }} 
                    <!-- <span class="required-input">*</span> -->
                    </label
                  >
                  <!-- <Dropdown
                    :disabled="isDisabledAmphur == 1"
                    v-model="amphurSelect"
                    :options="amphurOptions"
                    optionLabel="amphur_name"
                    :class="{ 'p-invalid': error_select_amphur && !amphurSelect }"
                    :filter="true"
                    :placeholder="$t('placeholderSelectBox')"
                    :showClear="true"
                  > -->
                  <Dropdown
                    :disabled="true"
                    v-model="amphurSelect"
                    :options="amphurOptions"
                    optionLabel="amphur_name"
                    :class="{ 'p-invalid': error_select_amphur && !amphurSelect }"
                    :filter="true"
                    :placeholder="$t('placeholderSelectBox')"
                    :showClear="true"
                    :clearFilterDropdown="dropdownClearFilerValue"
                  >
                    <template #value="amphurOptions">
                      <div v-if="amphurOptions.value">
                        <div>{{ amphurOptions.value.amphur_name }}</div>
                      </div>
                      <span v-else>
                        {{ amphurOptions.placeholder }}
                      </span>
                    </template>
                    <template #option="amphurOptions">
                      <div>{{ amphurOptions.option.amphur_name }}</div>
                    </template>
                  </Dropdown>
                  <small
                    class="p-invalid"
                    v-if="error_select_amphur && !amphurSelect"
                    >{{ $t("country_select_amphur_validate") }}</small
                  >
                </div>
              </div>
          
              <div class="p-formgrid p-grid p-mt-3">
                <!-- <div class="p-field p-col-4">
                  <label for="country_tambon_code"
                    >{{ $t("country_tambon_code") }}
                    <span class="required-input">*</span></label
                  >
                  <InputNumber
                    id="country_tambon_code"
                    v-model="country_tambon_code"
                    required="true"
                    autofocus
                    :useGrouping="false"
                    :class="{
                      'p-invalid':
                        error_country_tambon_code && !country_tambon_code,
                    }"
                  />
                  <small
                    class="p-invalid"
                    v-if="error_country_tambon_code && !country_tambon_code"
                    >{{ $t("country_tambon_code_validate") }}</small
                  >
                </div> -->
                <div class="p-field p-col-12 p-mt-2">
                  <label for="country_tambon_name"
                    >{{ $t("country_tambon_name") }}
                    <span class="required-input">*</span></label
                  >
                  <InputText
                    id="country_tambon_name"
                    type="text"
                    v-model="country_tambon_name"
                    required="true"
                    autofocus
                    :class="{
                      'p-invalid':
                        error_country_tambon_name && !country_tambon_name,
                    }"
                  />
                  <small
                    class="p-invalid"
                    v-if="error_country_tambon_name && !country_tambon_name"
                    >{{ $t("country_tambon_name_validate") }}</small
                  >
                </div>
                <!-- <div class="p-field p-col-4">
                  <label for="country_postcode"
                    >{{ $t("postcode") }}
                    <span class="required-input">*</span></label
                  >
                  <InputNumber
                    id="country_postcode"
                    v-model="country_postcode"
                    :maxDigits="5"
                    :useGrouping="false"
                    :class="{
                      'p-invalid': error_country_postcode && !country_postcode,
                    }"
                  />
                  <small
                    class="p-invalid"
                    v-if="error_country_postcode && !country_postcode"
                    >{{ $t("country_postcode_validate") }}</small
                  >
                </div> -->
              </div>
          </div>
          <div v-else>

            <div class="p-formgrid p-grid">
                <div class="p-field p-col-6">
                  <label for="provinceOptions"
                    >{{ $t("province") }}
                    <!-- <span class="required-input">*</span> -->
                  </label>
                  <Dropdown
                    v-model="provinceSelect"
                    :disabled="true"
                    @change="someHandler"
                    :options="provinceOptions"
                    optionLabel="province_name"
                    :filter="true"
                    :class="{
                      'p-invalid': error_select_province && !provinceSelect,
                    }"
                    :placeholder="$t('placeholderSelectBox')"
                    :showClear="true"
                    :clearFilterDropdown="dropdownClearFilerValue"
                  >
                    <template #value="provinceOptions">
                      <div v-if="provinceOptions.value">
                        <div>{{ provinceOptions.value.province_name }}</div>
                      </div>
                      <span v-else>
                        {{ provinceOptions.placeholder }}
                      </span>
                    </template>
                    <template #option="provinceOptions">
                      <div>{{ provinceOptions.option.province_name }}</div>
                    </template>
                  </Dropdown>
                  <small
                    class="p-invalid"
                    v-if="error_select_province && !provinceSelect"
                    >{{ $t("country_select_province_validate") }}</small
                  >
                </div>
                <div class="p-field p-col-6">
                  <label for="amphurOptions"
                    >{{ $t("amphur") }} 
                    <!-- <span class="required-input">*</span> -->
                    </label
                  >
                  <Dropdown
                  :disabled="true"
                    v-model="amphurSelect"
                    :options="amphurOptions"
                    optionLabel="amphur_name"
                    :class="{ 'p-invalid': error_select_amphur && !amphurSelect }"
                    :filter="true"
                    :placeholder="$t('placeholderSelectBox')"
                    :showClear="true"
                    :clearFilterDropdown="dropdownClearFilerValue"
                  >
                    <template #value="amphurOptions">
                      <div v-if="amphurOptions.value">
                        <div>{{ amphurOptions.value.amphur_name }}</div>
                      </div>
                      <span v-else>
                        {{ amphurOptions.placeholder }}
                      </span>
                    </template>
                    <template #option="amphurOptions">
                      <div>{{ amphurOptions.option.amphur_name }}</div>
                    </template>
                  </Dropdown>
                  <small
                    class="p-invalid"
                    v-if="error_select_amphur && !amphurSelect"
                    >{{ $t("country_select_amphur_validate") }}</small
                  >
                </div>
              </div>
              <!-- เพิ่ม -->
              <div class="p-formgrid p-grid p-mt-3">
                <div class="p-field p-col-12">
                    <label for="country_tambon_name"
                      >{{ $t("country_tambon_name") }}
                      <span class="required-input">*</span></label
                    >
                    <Dropdown
                      v-model="tambon_table_Select"
                      
                      :options="tambon_table_Options"
                      optionLabel="tambon_name"
                      :filter="true"
                      :class="{
                        'p-invalid': error_country_tambon_name && !tambon_table_Select,
                      }"
                      :placeholder="$t('placeholderSelectBox')"
                      :showClear="true"
                      :clearFilterDropdown="dropdownClearFilerValue"
                    >
                      <template #value="tambonOptions">
                        <div v-if="tambonOptions.value">
                          <div>{{ tambonOptions.value.tambon_name }}</div>
                        </div>
                        <span v-else>
                          {{ tambonOptions.placeholder }}
                        </span>
                      </template>
                      <template #option="tambonOptions">
                        <div>{{ tambonOptions.option.tambon_name }}</div>
                      </template>
                    </Dropdown>
                    <small
                      class="p-invalid"
                      v-if="(error_country_tambon_name && !tambon_table_Select)"
                      >{{ $t("country_tambon_name_validate") }}</small
                    >
                  </div>
                </div>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          v-if="selectedDataTambon != ''"
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearData()"
        />
        <Button
          v-else
          :label="$t('clearBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearData()"
        />
        <Button
        v-if="selectedDataTambon != ''"
          :label="$t('saveBtn')"
          icon="pi pi-check"
          class="p-button-text"
          @click="saveTambon()"
        />
        <Button
        v-else
          :label="$t('saveBtn')"
          icon="pi pi-check"
          class="p-button-text"
          @click="saveTambon2()"
        />
      </template>
    </Dialog>

    <Dialog
      :modal="true"
      :header="$t('ConfirmDelete')"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <i
          class="pi pi-exclamation-triangle p-mr-3 p-mt2"
          style="font-size: 2rem"
        />
        <span>{{ $t("ConfirmDeleteSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmation = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="confirmDelete()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <!-- Are you sure for close this modal -->
    <Dialog
      :modal="true"
      :header="$t('ConfirmCloseModal')"
      :visible.sync="displayConfirmationCloseModal"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <span>{{ $t("ConfirmCloseModalSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmationCloseModal = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="closeAllModal()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  name: "system-country",
  data() {
    return {
      dropdownClearFilerValue:0,
      checkRole:null,
      checkView_data:null,
      checkAdd_data:null,
      checkEdit_data:null,
      checkDelete_data:null,
      keyword: "",
      filters: {},
      temp: null,
      displayConfirmation: false,
      deleteAt: "",
      province_table: [],
      selectedProvince: null,
      amphur_table: [],
      selectedAmphur: null,
      tambon_table: [],

      provinceOptions: [],
      amphurOptions: [],

      provinceModal: false,
      amphurModal: false,
      tambonModal: false,

      header_province: this.$i18n.t("country_province_modal_title_add"),
      selectedDataProvince: "",
      country_province_code: null,
      country_province_name: "",
      error_country_province_code: false,
      error_country_province_name: false,

      header_amphur: this.$i18n.t("country_amphur_modal_title_add"),
      selectedDataAmphur: "",
      provinceSelect: null,
      country_amphur_code: null,
      country_amphur_name: "",
      
      error_select_province: false,
      error_country_amphur_code: false,
      error_country_amphur_name: false,

      header_tambon: this.$i18n.t("country_tambon_modal_title_add"),
      selectedDataTambon: "",
      isDisabledAmphur: 1,
      amphurSelect: null,
      country_tambon_code: null,
      country_tambon_name: "",
      country_postcode: null,
      error_select_amphur: false,
      error_country_tambon_code: false,
      error_country_tambon_name: false,
      error_country_postcode: false,

      isDisabledAddAmphur: 1,
      isDisabledAddTambon: 1,

      check_duplicate_province: "",
      check_duplicate_amphur: "",
      check_duplicate_tambon: "",

      isDisableSelectProvince: 0,

      displayConfirmationCloseModal: false,
      tempDisplayConfirmationCloseModal: "",
      tempFor_displayConfirmationCloseModal: "",

      province_table_Options:[],
      province_table_Select:null,

      amphur_table_Select:null,
      amphur_table_Options:[],

      tambon_table_Select:null,
      tambon_table_Options:[],
    };
  },
  watch: {
    provinceModal(val) {
      if (val == false) {
        if (
          this.tempFor_displayConfirmationCloseModal == "" &&
          this.selectedDataProvince == "" &&
          this.country_province_code != null &&
          this.country_province_name != ""
        ) {
          // this.displayConfirmationCloseModal = true;
          this.$fire({
                    title: "ยืนยันการปิดหน้าต่างจัดการข้อมูล",
                    text: "คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    
                    if (result.value) {
                     
                      this.provinceModal = false;
                      this.clearData();
                      
                    }else{
                      this.provinceModal = true;
                      
                    }
                  })
          this.tempDisplayConfirmationCloseModal = "province";
        }else if (this.province_table_Select != null) {
          this.$fire({
                    title: "ยืนยันการปิดหน้าต่างจัดการข้อมูล",
                    text: "คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    
                    if (result.value) {
                     
                      this.provinceModal = false;
                      this.clearData();
                      
                    }else{
                      this.provinceModal = true;
                      
                    }
                  })
        }
         else {
          this.clearData();
        }
      }
    },

    async amphurModal(val) {
      if (val == false) {
        if (
          this.tempFor_displayConfirmationCloseModal == "" &&
          this.selectedDataAmphur == "" &&
          this.provinceSelect != null &&
          this.country_amphur_code != null &&
          this.country_amphur_name != ""
        ) {
          // this.displayConfirmationCloseModal = true;
          this.$fire({
                    title: "ยืนยันการปิดหน้าต่างจัดการข้อมูล",
                    text: "คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    
                    if (result.value) {
                     
                      this.amphurModal = false;
                      this.clearData();
                      
                    }else{
                      this.amphurModal = true;
                      
                    }
                  })
          this.tempDisplayConfirmationCloseModal = "amphur";
        } 
        else if(
          this.tempFor_displayConfirmationCloseModal == "" &&
          this.provinceSelect != null &&
          this.amphur_table_Select != null){
          this.$fire({
                    title: "ยืนยันการปิดหน้าต่างจัดการข้อมูล",
                    text: "คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    
                    if (result.value) {
                     
                      this.amphurModal = false;
                      this.clearData();
                      
                    }else{
                      this.amphurModal = true;
                      
                    }
                  })
        }
        else {
          this.clearData();
        }
      } else {
        this.provinceSelect = {
          province_id: this.selectedProvince.province_id,
          province_name: this.selectedProvince.province_name,
        };
        await this.axios
          .post(`${this.$url_service}/general/country`, {
            body: {
              topic: "get-province",
            },
          })
          .then((response) => (this.provinceOptions = response.data.data));
      }
    },

    async tambonModal(val) {

      if (val == false) {
        if (
          this.tempFor_displayConfirmationCloseModal == "" &&
          this.selectedDataTambon == "" &&
          this.provinceSelect != null &&
          this.amphurSelect != null &&
          this.country_tambon_code != null &&
          this.country_tambon_name != "" &&
          this.country_postcode != null
        ) {
          // this.displayConfirmationCloseModal = true;
          // console.log("4444")
          this.$fire({
                    title: "ยืนยันการปิดหน้าต่างจัดการข้อมูล",
                    text: "คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    
                    if (result.value) {
                     
                      this.tambonModal = false;
                      this.clearData();
                      
                    }else{
                      this.tambonModal = true;
                      
                    }
                  })
          this.tempDisplayConfirmationCloseModal = "tambon";

        }else if(this.tempFor_displayConfirmationCloseModal == "" &&
          this.provinceSelect != null &&
          this.amphurSelect != null &&
          this.tambon_table_Select != null){

            this.$fire({
                    title: "ยืนยันการปิดหน้าต่างจัดการข้อมูล",
                    text: "คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    
                    if (result.value) {
                     
                      this.tambonModal = false;
                      this.clearData();
                      
                    }else{
                      this.tambonModal = true;
                      
                    }
                  })
        }
         else {

          this.clearData();
        }
      } else {
        if (this.selectedProvince != null) {
          this.provinceSelect = {
            province_id: this.selectedProvince.province_id,
            province_name: this.selectedProvince.province_name,
          };
          await this.axios
            .post(`${this.$url_service}/general/country`, {
              body: {
                topic: "get-province",
              },
            })
            .then((response) => (this.provinceOptions = response.data.data));
        }

        if (this.selectedAmphur != null) {
          this.provinceSelect = {
            province_id: this.selectedProvince.province_id,
            province_name: this.selectedProvince.province_name,
          };
          this.amphurSelect = {
            amphur_id: this.selectedAmphur.amphur_id,
            amphur_name: this.selectedAmphur.amphur_name,
          };
        }
      }
    },

    displayConfirmationCloseModal(val) {
      if (val == true) {
        if (this.tempDisplayConfirmationCloseModal == "province") {
          this.provinceModal = true;
        }
        if (this.tempDisplayConfirmationCloseModal == "amphur") {
          this.amphurModal = true;
        }
        if (this.tempDisplayConfirmationCloseModal == "tambon") {
          this.tambonModal = true;
        }
      }
    },

    async provinceSelect(val) {
      if (val != null) {
        this.isDisabledAmphur = 0;
        await this.axios
          .post(`${this.$url_service}/general/country`, {
            body: {
              topic: "get-amphur",
              province_id: val.province_id,
            },
          })
          .then((response) => (this.amphurOptions = response.data.data));
      } else {
        this.isDisabledAmphur = 1;
        this.amphurSelect = null;
      }
    },
    // async province_table_Select(val){

    // },
    check_duplicate_province(val) {
      if (val == "duplicate province") {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "เพิ่มข้อมูลจังหวัดไม่สำเร็จ",
        //   detail: "มีข้อมูลจังหวัดนี้ในระบบแล้ว",
        //   life: 3000,
        // });
        this.$fire({
              type: "error",
              title:"เพิ่มข้อมูลจังหวัดไม่สำเร็จ",
              text: "มีข้อมูลจังหวัดนี้ในระบบแล้ว",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
      } else {
        this.notiManage(1, "prov");
      }
      this.check_duplicate_province = null
    },

    check_duplicate_amphur(val) {
      if (val == "duplicate amphur") {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "เพิ่มข้อมูลอำเภอไม่สำเร็จ",
        //   detail: "มีข้อมูลอำเภอดังกล่าวในจังหวัดนี้แล้ว",
        //   life: 3000,
        // });
        this.$fire({
              type: "error",
              title:"เพิ่มข้อมูลอำเภอไม่สำเร็จ",
              text: "มีข้อมูลอำเภอดังกล่าวในจังหวัดนี้แล้ว",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
      } else {
        this.notiManage(1, "amp");
      }
      this.check_duplicate_amphur = null
    },

    check_duplicate_tambon(val) {
      if (val == "duplicate tambon") {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "เพิ่มข้อมูลตำบลไม่สำเร็จ",
        //   detail: "มีข้อมูลตำบลดังกล่าวในอำเภอนี้แล้ว",
        //   life: 3000,
        // });
        this.$fire({
              type: "error",
              title:"เพิ่มข้อมูลตำบลไม่สำเร็จ",
              text: "มีข้อมูลตำบลดังกล่าวในอำเภอนี้แล้ว",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
      } else {
        this.notiManage(1, "tam");
      }
      this.check_duplicate_tambon = null
    },
    // async province_table_Options(){
    //   await this.axios
    //       .post(`${this.$url_service}/general/country`, {
    //         body: {
    //           topic: "get-province-flag0",
    //         },
    //       })
    //       .then((response) => (this.province_table_Options = response.data.data));
    // },
    // async amphur_table_Options(){
    //   await this.axios
    //       .post(`${this.$url_service}/general/country`, {
    //         body: {
    //           topic: "get-amphur-flag0",
    //           province_id: this.selectedProvince.province_id,
    //         },
    //       })
    //       .then((response) => (this.amphur_table_Options = response.data.data));
    // }
  },
  created() {
    this.initialData("prov");
    this.checkRole = JSON.parse(localStorage.getItem("data")).permission_id;

    this.checkView_data = JSON.parse(localStorage.getItem("data")).view_data;
    this.checkAdd_data = JSON.parse(localStorage.getItem("data")).add_data;
    this.checkEdit_data = JSON.parse(localStorage.getItem("data")).edit_data;
    this.checkDelete_data = JSON.parse(localStorage.getItem("data")).delete_data;

    // console.log(`checkRole = ${this.checkRole} `);
    // console.log(`checkView_data = ${this.checkView_data} `);
    // console.log(`checkAdd_data = ${this.checkAdd_data} `);
    // console.log(`checkEdit_data = ${this.checkEdit_data} `);
    // console.log(`checkDelete_data = ${this.checkDelete_data} `);
    // this.province_load()
    // this.amphur_load()
    


  },

  methods: {
    async initialData(type) {
      if (type == "prov") {
        await this.axios
          .post(`${this.$url_service}/general/country`, {
            body: {
              topic: "get-province",
            },
          })
          .then((response) => {(this.province_table = response.data.data)
            // console.log("response.data.data",response.data.data)
          });
      }
      if (type == "amp") {
        await this.axios
          .post(`${this.$url_service}/general/country`, {
            body: {
              topic: "get-amphur",
              province_id: this.selectedProvince.province_id,
            },
          })
          .then((response) => {
            (this.amphur_table = response.data.data)
            // console.log("this.amphur_table",this.amphur_table)
          });
      }
      if (type == "tam") {
        await this.axios
          .post(`${this.$url_service}/general/country`, {
            body: {
              topic: "get-tambon",
              amphur_id: this.selectedAmphur.amphur_id,
            },
          })
          .then((response) => (this.tambon_table = response.data.data));
      }
      
    },
    async province_load(){
      await this.axios
          .post(`${this.$url_service}/general/country`, {
            body: {
              topic: "get-province-flag0",
            },
          })
          .then((response) => (this.province_table_Options = response.data.data));
    },
    async amphur_load(){
      // console.log("0000")
      await this.axios
          .post(`${this.$url_service}/general/country`, {
            body: {
              topic: "get-amphur-flag0",
              province_id: this.selectedProvince.province_id,
            },
          })
          .then((response) => {
            (this.amphur_table_Options = response.data.data)
            // console.log("this.amphur_table_Options",this.amphur_table_Options)
          });
    },
    async tambon_load(){
      // console.log("0000")
      await this.axios
          .post(`${this.$url_service}/general/country`, {
            body: {
              topic: "get-tambon-flag0",
              amphur_id: this.selectedAmphur.amphur_id,
            },
          })
          .then((response) => {
            (this.tambon_table_Options = response.data.data)
            // console.log("this.tambon_table",this.tambon_table)
          });
    },
    closeAllModal() {
      this.displayConfirmationCloseModal = false;
      this.clearData();

      if (this.tempDisplayConfirmationCloseModal == "province") {
        this.provinceModal = false;
        // console.log("Close province and don`t save data");
      }
      if (this.tempDisplayConfirmationCloseModal == "amphur") {
        this.amphurModal = false;
        // console.log("Close amphur and don`t save data");
      }
      if (this.tempDisplayConfirmationCloseModal == "tambon") {
        this.tambonModal = false;
        // console.log("Close tambon and don`t save data");
      }
    },

    someHandler() {
      this.amphurSelect = null;
      this.amphurOptions = [];
    },

    async onRowSelectProvince(event) {
      // this.$toast.add({
      //   severity: "info",
      //   summary: "เลือกจังหวัด",
      //   detail: event.data.province_name,
      //   life: 3000,
      // });
      this.$fire({
              type: "info",
              title:"เลือกจังหวัด",
              text: event.data.province_name,
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
      this.initialData("amp");
      this.isDisabledAddAmphur = 0;
      this.tambon_table = [];
      this.isDisabledAddTambon = 1;
    },

    async onRowSelectAmphur(event) {
      // this.$toast.add({
      //   severity: "info",
      //   summary: "เลือกอำเภอ",
      //   detail: event.data.amphur_name,
      //   life: 3000,
      // });
      this.$fire({
              type: "info",
              title:"เลือกอำเภอ",
              text: event.data.amphur_name,
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
      this.initialData("tam");
      this.isDisabledAddTambon = 0;
    },

    async confirmDelete() {
      this.displayConfirmation = false;
      if (this.deleteAt == "province") {
        await this.axios
          .post(
            `${this.$url_service}/general/country?user=${this.getUsername()}`,
            {
              body: {
                topic: "delete-province",
                id: this.temp,
              },
            }
          )
          .then(() => this.initialData("prov"));
        this.notiManage(3, "prov");
      }
      if (this.deleteAt == "amphur") {
        await this.axios
          .post(
            `${this.$url_service}/general/country?user=${this.getUsername()}`,
            {
              body: {
                topic: "delete-amphur",
                province_id: this.selectedProvince.province_id,
                id: this.temp,
              },
            }
          )
          .then(() => this.initialData("amp"));
        this.notiManage(3, "amp");
      }
      if (this.deleteAt == "tambon") {
        await this.axios
          .post(
            `${this.$url_service}/general/country?user=${this.getUsername()}`,
            {
              body: {
                topic: "delete-tambon",
                amphur_id: this.selectedAmphur.amphur_id,
                id: this.temp,
              },
            }
          )
          .then(() => this.initialData("tam"));
        this.notiManage(3, "tam");
      }
    },

    async saveProvince() {
      if (
        this.country_province_code == null ||
        this.country_province_name == ""
      ) {
        if (this.country_province_code == null) {
          this.error_country_province_code = true;
        }
        if (this.country_province_name == "") {
          this.error_country_province_name = true;
        }
      } else {
        if (this.selectedDataProvince == "") {
          await this.axios
            .post(
              `${this.$url_service}/general/country?user=${this.getUsername()}`,
              {
                body: {
                  topic: "add-province",
                  code: this.country_province_code,
                  name: this.country_province_name,
                },
              }
            )
            .then((response) => {
              (this.check_duplicate_province = response.data.message),
                this.initialData("prov");
            });
          this.tempFor_displayConfirmationCloseModal = "add";
          this.provinceModal = false;
          this.clearData();
        } else {
          await this.axios
            .post(
              `${this.$url_service}/general/country?user=${this.getUsername()}`,
              {
                body: {
                  topic: "edit-province",
                  province_id: this.temp,
                  code: this.country_province_code,
                  name: this.country_province_name,
                },
              }
            )
            .then(() => this.initialData("prov"));
          this.notiManage(2, "prov");
          this.provinceModal = false;
          this.clearData();
        }
      }
    },

    async saveProvince2() {
      // console.log("this.province_table_Options",this.province_table_Options)
      // console.log("this.province_table_Select",this.province_table_Select)
      if (
        this.province_table_Select == null 
      ) {
        if (this.province_table_Select == null) {
          this.error_select_province = true;
        }

      } else {
        if (this.selectedDataProvince == "") {
          await this.axios
            .post(
              `${this.$url_service}/general/country?user=${this.getUsername()}`,
              {
                body: {
                  // topic: "add-province",
                  topic: "add-province-new",
                  id: this.province_table_Select.province_id,
                  // name: this.province_table_Select.province_name,
                },
              }
            )
            .then((response) => {
              (this.check_duplicate_province = response.data.message),
                this.initialData("prov");
            });
          this.tempFor_displayConfirmationCloseModal = "add";
          this.provinceModal = false;
          this.clearData();
        } else {
          await this.axios
            .post(
              `${this.$url_service}/general/country?user=${this.getUsername()}`,
              {
                body: {
                  topic: "edit-province",
                  province_id: this.temp,
                  code: this.country_province_code,
                  name: this.country_province_name,
                },
              }
            )
            .then(() => this.initialData("prov"));
          this.notiManage(2, "prov");
          this.provinceModal = false;
          this.clearData();
        }
      }
    },

    async saveAmphur() {
      if (
        this.provinceSelect == null ||
        this.country_amphur_code == null ||
        this.country_amphur_name == ""
      ) {
        if (this.provinceSelect == null) {
          this.error_select_province = true;
        }
        if (this.country_amphur_code == null) {
          this.error_country_amphur_code = true;
        }
        if (this.country_amphur_name == "") {
          this.error_country_amphur_name = true;
        }
      } else {
        if (this.selectedDataAmphur == "") {
          await this.axios
            .post(
              `${this.$url_service}/general/country?user=${this.getUsername()}`,
              {
                body: {
                  topic: "add-amphur",
                  province_id: this.provinceSelect.province_id,
                  code: this.country_amphur_code,
                  name: this.country_amphur_name,
                },
              }
            )
            .then((response) => {
              (this.check_duplicate_amphur = response.data.message),
                this.initialData("amp");
            });
          this.tempFor_displayConfirmationCloseModal = "add";
          this.amphurModal = false;
          this.clearData();
        } else {
          await this.axios
            .post(
              `${this.$url_service}/general/country?user=${this.getUsername()}`,
              {
                body: {
                  topic: "edit-amphur",
                  id: this.temp,
                  province_id: this.provinceSelect.province_id,
                  code: this.country_amphur_code,
                  name: this.country_amphur_name,
                },
              }
            )
            .then(() => this.initialData("amp"));
          this.notiManage(2, "amp");
          this.amphurModal = false;
          this.clearData();
        }
      }
    },

    async saveAmphur2() {
      
      if (
        this.provinceSelect == null ||
        this.amphur_table_Select == null 
      ) {
        if (this.provinceSelect == null) {
          this.error_select_province = true;
        }
        if (this.amphur_table_Select == null) {
          this.error_country_amphur_name = true;
        }
      } else {
        if (this.selectedDataAmphur == "") {
          await this.axios
            .post(
              `${this.$url_service}/general/country?user=${this.getUsername()}`,
              {
                body: {
                  // topic: "add-amphur",
                  topic: "add-amphur-new",
                  id: this.amphur_table_Select.amphur_id,
                  province_id: this.provinceSelect.province_id,
                  // code: this.country_amphur_code,
                  // name: this.country_amphur_name,
                },
              }
            )
            .then((response) => {
              (this.check_duplicate_amphur = response.data.message),
              // console.log("response.data",response)
                this.initialData("amp");
            });
          this.tempFor_displayConfirmationCloseModal = "add";
          this.amphurModal = false;
          this.clearData();
        } else {
          await this.axios
            .post(
              `${this.$url_service}/general/country?user=${this.getUsername()}`,
              {
                body: {
                  topic: "edit-amphur",
                  id: this.temp,
                  province_id: this.provinceSelect.province_id,
                  code: this.country_amphur_code,
                  name: this.country_amphur_name,
                },
              }
            )
            .then(() => this.initialData("amp"));
          this.notiManage(2, "amp");
          this.amphurModal = false;
          this.clearData();
        }
      }
    },

    async saveTambon() {
      if (
        this.provinceSelect == null ||
        this.amphurSelect == null ||
        this.country_tambon_code == null ||
        this.country_tambon_name == "" ||
        this.country_postcode == null
      ) {
        if (this.provinceSelect == null) {
          this.error_select_province = true;
        }
        if (this.amphurSelect == null) {
          this.error_select_amphur = true;
        }
        if (this.country_tambon_code == null) {
          this.error_country_tambon_code = true;
        }
        if (this.country_tambon_name == "") {
          this.error_country_tambon_name = true;
        }
        if (this.country_postcode == null) {
          this.error_country_postcode = true;
        }
      } else {
        if (this.selectedDataTambon == "") {
          await this.axios
            .post(
              `${this.$url_service}/general/country?user=${this.getUsername()}`,
              {
                body: {
                  topic: "add-tambon",
                  amphur_id: this.amphurSelect.amphur_id,
                  code: this.country_tambon_code,
                  name: this.country_tambon_name,
                  postcode: this.country_postcode,
                },
              }
            )
            .then((response) => {
              (this.check_duplicate_tambon = response.data.message),
                this.initialData("tam");
            });
          this.tempFor_displayConfirmationCloseModal = "add";
          this.tambonModal = false;
          this.clearData();
        } else {
          await this.axios
            .post(
              `${this.$url_service}/general/country?user=${this.getUsername()}`,
              {
                body: {
                  topic: "edit-tambon",
                  id: this.temp,
                  amphur_id: this.amphurSelect.amphur_id,
                  code: this.country_tambon_code,
                  name: this.country_tambon_name,
                  postcode: this.country_postcode,
                },
              }
            )
            .then(() => this.initialData("tam"));
          this.notiManage(2, "tam");
          this.tambonModal = false;
          this.clearData();
        }
      }
    },

    async saveTambon2() {
      if (
        this.provinceSelect == null ||
        this.amphurSelect == null ||
        this.tambon_table_Select == null
      ) {
        if (this.provinceSelect == null) {
          this.error_select_province = true;
        }
        if (this.amphurSelect == null) {
          this.error_select_amphur = true;
        }
        if (this.tambon_table_Select == null) {
          this.error_country_tambon_name = true;
        }
      } else {
        if (this.selectedDataTambon == "") {
          await this.axios
            .post(
              `${this.$url_service}/general/country?user=${this.getUsername()}`,
              {
                body: {
                  // topic: "add-tambon",
                  topic: "add-tambon-new",
                  id:this.tambon_table_Select.tambon_id,
                  amphur_id: this.amphurSelect.amphur_id,
                  // code: this.country_tambon_code,
                  // name: this.country_tambon_name,
                  // postcode: this.country_postcode,
                },
              }
            )
            .then((response) => {
              (this.check_duplicate_tambon = response.data.message),
                this.initialData("tam");
            });
          this.tempFor_displayConfirmationCloseModal = "add";
          this.tambonModal = false;
          this.clearData();
        } else {
          await this.axios
            .post(
              `${this.$url_service}/general/country?user=${this.getUsername()}`,
              {
                body: {
                  topic: "edit-tambon",
                  id: this.temp,
                  amphur_id: this.amphurSelect.amphur_id,
                  code: this.country_tambon_code,
                  name: this.country_tambon_name,
                  postcode: this.country_postcode,
                },
              }
            )
            .then(() => this.initialData("tam"));
          this.notiManage(2, "tam");
          this.tambonModal = false;
          this.clearData();
        }
      }
    },

    notiManage(manage, type) {
      let topic, detail;
      if (manage == 1) {
        topic = "เพิ่มข้อมูลสำเร็จ";
      } else if (manage == 2) {
        topic = "แก้ไขข้อมูลสำเร็จ";
      } else {
        topic = "ลบข้อมูลสำเร็จ";
      }

      if (type == "prov") {
        detail = "ข้อมูลจังหวัด";
        if (manage == 2) {
          detail += ` ${this.country_province_name}`;
        }

        this.amphur_table = [];
        this.tambon_table = [];
      }
      if (type == "amp") {
        detail = "ข้อมูลอำเภอ";
        if (manage == 2) {
          detail += ` ${this.country_amphur_name}`;
        }

        this.tambon_table = [];
      }
      if (type == "tam") {
        detail = "ข้อมูลตำบล";
        if (manage == 2) {
          detail += ` ${this.country_tambon_name}`;
        }
      }

      // this.$toast.add({
      //   severity: "success",
      //   summary: topic,
      //   detail: detail,
      //   life: 3000,
      // });
      this.$fire({
              type: "success",
              title:topic,
              text: detail,
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
    },

    async editProvince(data) {
      this.header_province = this.$i18n.t("country_province_modal_title_edit");
      await this.axios
        .post(`${this.$url_service}/general/country`, {
          body: {
            topic: "showone-province",
            id: data,
          },
        })
        .then((response) => {
          (this.selectedDataProvince = response.data.data),
            (this.country_province_code = Number(
              response.data.data.province_code
            )),
            (this.country_province_name = response.data.data.province_name);
        });
    },

    async editAmphur(data) {
      this.header_amphur = this.$i18n.t("country_amphur_modal_title_edit");
      await this.axios
        .post(`${this.$url_service}/general/country`, {
          body: {
            topic: "showone-amphur",
            id: data,
          },
        })
        .then((response) => {
          (this.selectedDataAmphur = response.data.data),
            (this.provinceSelect = {
              province_id: response.data.data.province_id,
              province_name: response.data.data.province_name,
            }),
            (this.country_amphur_code = Number(response.data.data.amphur_code)),
            (this.country_amphur_name = response.data.data.amphur_name);
        });
    },

    async editTambon(data) {
      this.header_tambon = this.$i18n.t("country_tambon_modal_title_edit");
      await this.axios
        .post(`${this.$url_service}/general/country`, {
          body: {
            topic: "showone-tambon",
            id: data,
          },
        })
        .then((response) => {
          (this.selectedDataTambon = response.data.data),
            (this.provinceSelect = {
              province_id: response.data.data.province_id,
              province_name: response.data.data.province_name,
            }),
            (this.amphurSelect = {
              amphur_id: response.data.data.amphur_id,
              amphur_name: response.data.data.amphur_name,
            }),
            (this.country_tambon_code = Number(response.data.data.tambon_code)),
            (this.country_tambon_name = response.data.data.tambon_name),
            (this.country_postcode = Number(response.data.data.postcode));
        });
    },

    clearData() {
      this.dropdownClearFilerValue +=1;
      //Edit data
      if (
        this.selectedDataProvince != "" ||
        this.selectedDataAmphur != "" ||
        this.selectedDataTambon != ""
      ) {
        this.temp = null;
        this.displayConfirmation = false;
        if (this.selectedDataProvince != "") {
          this.header_province = this.$i18n.t(
            "country_province_modal_title_add"
          );
          this.provinceModal = false;
          this.selectedDataProvince = "";
          this.setDefaultProvince();
        }
        if (this.selectedDataAmphur != "") {
          this.header_amphur = this.$i18n.t("country_amphur_modal_title_add");
          this.amphurModal = false;
          this.selectedDataAmphur = "";
          this.setDefaultAmphur();
        }
        if (this.selectedDataTambon != "") {
          this.header_tambon = this.$i18n.t("country_tambon_modal_title_add");
          this.tambonModal = false;
          this.selectedDataTambon = "";
          this.setDefaultTambon();
        }
        //Add data
      } else {
        this.temp = null;
        this.displayConfirmation = false;

        this.header_province = this.$i18n.t("country_province_modal_title_add");
        this.header_amphur = this.$i18n.t("country_amphur_modal_title_add");
        this.header_tambon = this.$i18n.t("country_tambon_modal_title_add");

        this.setDefaultProvince();
        this.setDefaultAmphur();
        this.setDefaultTambon();
      }
    },

    setDefaultProvince() {
      this.tempFor_displayConfirmationCloseModal = "";
      this.country_province_code = null;
      this.country_province_name = "";
      this.error_country_province_code = false;
      this.error_country_province_name = false;
      this.province_table_Select = null
    },

    setDefaultAmphur() {
      this.tempFor_displayConfirmationCloseModal = "";
      this.provinceSelect = null;
      this.country_amphur_code = null;
      this.country_amphur_name = "";
      this.error_select_province = false;
      this.error_country_amphur_code = false;
      this.error_country_amphur_name = false;
      this.amphur_table_Select= null;

    },

    setDefaultTambon() {
      this.tempFor_displayConfirmationCloseModal = "";
      this.provinceSelect = null;
      this.amphurSelect = null;
      this.country_tambon_code = null;
      this.country_tambon_name = "";
      this.country_postcode = null;
      this.error_select_province = false;
      this.error_select_amphur = false;
      this.error_country_tambon_code = false;
      this.error_country_tambon_name = false;
      this.error_country_postcode = false;
      this.tambon_table_Select=null;
    },
    alertDisplay(temp) {
      this.$fire({
                    title: "ยืนยันการลบข้อมูล",
                    text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    // console.log(temp)
                    if (result.value) {
                      // console.log(temp)
                      this.confirmDelete(temp)
                    }
                  })
    },
  },
};
</script>

<style scoped>
.p-field {
  margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}
</style>
